<template>
    <div class="wrap">
        <van-sticky>
            <div class="header">
                <NavigateBar :title="className" @handleBack="handleBack"/>
                <van-tabs v-model="active" color="#286BFF" title-active-color="#286BFF" title-inactive-color="#848586" @change="tabChange">
                <van-tab name="1">
                    <template #title> 未完成</template>
                </van-tab>
                <van-tab name="2">
                    <template #title> 已完成</template>
                </van-tab>
                <van-tab name="3">
                    <template #title> 草稿箱</template>
                </van-tab>
                </van-tabs>
            </div>
            <div class="line"></div>
            <div class="search-box">
                <van-search
                    v-model="keyword"
                    shape="round"
                    @search="handleSearchHomework"
                    @clear="handleSearchHomework"
                    placeholder="搜索章名称、节名称" />
            </div>
        </van-sticky>
        <div class="main">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-collapse v-model="activeNames[index]" v-for="(item, index) in chapterList" :key="item.id" class="collapseList" :border="false">
                    <van-collapse-item value-class="valueClass" :name="1" :title="item.name" :border="false">
                        <template slot="value">
                            <div class="hint">
                                {{ active == 1 ? '待完成：' : active == 2 ? '已完成：' : '草稿：' }}
                                <span :class="`done${active}`">{{ item.homework_count }}</span>
                            </div>
                        </template>
                        <div class="list">
                            <div class="list-item" :class="active == 2 ? 'done' : ''" v-for="tag in item.homework_list" :key="tag.id">
                                <template v-if="active == 1 || active == 3">
                                    <div class="chapter-title">
                                        <div class="wordage clamp2">
                                            作业名称：{{ tag.homework_name || tag.name }}
                                        </div>
                                    </div>
                                    <div class="chapter-des">
                                        <div class="topicNum-time">
                                            <div class="topicNum">
                                                题目数：{{ tag.question_count || tag.sum || 0 }}
                                            </div>
                                            <div class="time">
                                                截止：{{ tag.end_time }}
                                            </div>
                                        </div>
                                        <div class="btnBox">
                                            <div v-if="active == 1" class="btn" :class="tag.question_count > 0 ? '' : 'btnFlexDisabled'" @click=" tag.question_count > 0 ? toQuestionPaperPage(item,tag,'do') : ''">写作业</div>
                                            <div v-if="active == 3" class="btn" @click="toQuestionPaperPage(item,tag,'edit')">继续答题</div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="scoreStatus">
                                        <div class="score" :class="tag.mode == 3 ? 'running' : ''">
                                            <img :src="tag.mode == 3 ? require('@/assets/images/homeWork/scoreImg1.png') : require('@/assets/images/homeWork/scoreImg.png')" alt="">
                                            <div class="scoreNum flex-algin-center">
                                                成绩：
                                                <span v-if="tag.status == 2" class="done3 flex-algin-center" :class="tag.mode == 3 ? 'done4' : ''">{{ tag.score || 0 }}分 </span>
                                                <span v-else>暂无</span>
                                                <span class="whipptree">|</span> {{ tag.mode == 3 ? '逐题模式' : '考试模式' }}
                                            </div>
                                        </div>
                                        <div class="status">
                                            <div v-if="isLate(tag.create_time,tag.end_time)" class="tag late">迟交</div>
                                            <div v-if="tag.status == 1" class="tag noReviewed">待批阅</div>
                                            <div v-if="tag.status == 2" class="tag reviewed">已批阅</div>
                                        </div>
                                    </div>
                                    <div class="chapter-title">
                                        <div class="wordage clamp2">
                                            作业名称：{{ tag.name }}
                                        </div>
                                    </div>
                                    <div class="btnBox btnFlexDone">
                                            <div v-if="tag.status == 2" class="btn btnFlex practice" @click="toQuestionPaperPage(item,tag,'doPractice')">巩固练习</div>
                                            <div v-if="tag.status == 1" class="btn btnFlex" :class="tag.mode == 3 ? 'zhuti' : ''" @click="tag.mode !== 3 ?toQuestionPaperPage(item,tag,'edit') : ''">修改作业</div>
                                            <div v-if="tag.status == 2" class="btn btnFlex" @click="toQuestionPaperPage(item,tag,'check', 'view')">查看详情</div>
                                        </div>
                                </template>
                            </div>
                        </div>
                    </van-collapse-item>
                </van-collapse>
                <van-empty v-if="!chapterList.length" description="暂无章节数据" />
            </van-pull-refresh>
        </div>
        <van-popup v-model="isPracticeMode" position="bottom" round >
            <modeDialog :exerciseData="exerciseData" :title="modeData.modeTitle" :modeDialogType="modeData.modeDialogType" @practiceClick="practiceClick" @selectMode="selectMode"  @close="modeClose" />
        </van-popup>
    </div>
</template>

<script>
import NavigateBar from './navigateBar.vue';
import modeDialog from './refactorComponents/modeDialog.vue'
import Vue from 'vue';
import { Tab, Tabs, Collapse, CollapseItem, Search, PullRefresh, Sticky, Empty, Popup, Notify } from 'vant';
Vue.use(Tab, Tabs, Collapse, CollapseItem, Search, PullRefresh, Sticky, Empty, Popup, Notify);

export default {
    components: {
        NavigateBar,
        modeDialog
    }, 
    data () {
        return {
            active: '1',
            classId: '',
            className: '',
            courseId: '',
            total: 0,
            pageSize: 0,
            page: 1,
            activeNames: [],
            isLoading: false,
            chapterList: [],
            keyword: '',
            read_class: 0, // 0不更改，1全部已读
            isPracticeMode: false,
            modeData: { // 答题模式数据
                modeTitle: '巩固练习',
                modeDialogType: 1, // 1：巩固练习，2：答题模式
            },
            workType: '', // do 未完成写作业 doPractice 巩固练习 edit 修改作业 check 查看详情
            payload: null, // 跳转页面所需参数
            gonggulianxiData: {}, // 点击巩固练习保存当前数据
            exerciseData: {} // 调用接口获取巩固练习数据
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.path === '/homework1' || from.path === '/homework') {
            next(vm => {
                vm.read_class = 1
            });
        } else {
            next(vm => {
                vm.read_class = 0
            });
        }
    },
    created() {
        const { active = '1' } = JSON.parse(sessionStorage.getItem('cacheHomework') || '{}')
        const { course_id, class_id, className } = this.$route.query
        this.active = active
        this.courseId = course_id
        this.classId = class_id
        this.className = className
    },
    mounted(){
        window.addEventListener('scroll',this.handleScroll,true)
        this.getHomeWorkDetailList()
    },
    beforeDestroy(){
        window.removeEventListener("scroll",this.handleScroll,true)
    },
    computed:{
        isLate(){
            return function(create_time,end_time){
                if(new Date(create_time).getTime()>new Date(end_time).getTime()){
                    return true
                }else{
                    return false
                }
            }
        }
   },
    methods: {
        getconsolidationData() {
            this.$api.post('/user/question/stat', { ucq_id: this.gonggulianxiData.childItem.ucqid }).then(res => {
                if (res.data.code == 200) {
                    this.isPracticeMode = true
                    this.exerciseData = res.data.data
                } else {
                    Notify(res.data.message)
                }
            })
        },
        toQuestionPaperPage(item,childItem,type, mode) {
            let flag = 2
            let isShowAnswered = false // 是否显示已答 主要用于逐题模式中做题时未点确认直接切换题目后展示状态
            if (type == 'check') {
                flag = 0
            }
            if (type == 'edit' || type == 'do') {
                isShowAnswered = true
            }
            this.workType = type
            const payload = {
                qt_id: childItem.homework_id || childItem.qt_id,
                section_id: item.id || item.section_id,
                flag: flag,
                chapter_id: item.chapter_id || item.type == 'chapter' ? item.id : 0,
                end_time: childItem.end_time,
                cq_id: childItem.cq_id,
                ucqid: childItem.ucqid,
                status: childItem.status,
                isShowSubmit: mode ? false : true,
                titleName: childItem.name,
                isShowAnswered: isShowAnswered,
                ...{type}
            }
            console.log(childItem, 'childItem')
            console.log(payload, 'payload')
            this.modeData.modeDialogType = childItem.mode
            this.payload = payload
            sessionStorage.setItem('cacheHomework',JSON.stringify({active:this.active}))
            if (type == 'doPractice') {
                this.gonggulianxiData.flag = 0
                this.gonggulianxiData.item = item
                this.gonggulianxiData.childItem = childItem
                this.gonggulianxiData.type = type
                this.modeData.modeTitle = '巩固练习'
                this.modeData.modeDialogType = 1
                this.getconsolidationData()
                return
            }
            if (type == 'do' && childItem.mode == 2) {
                this.modeData.modeTitle = '答题模式'
                this.isPracticeMode = true
                return
            }
            if (type == 'doPractice' && childItem.mode == 2) {
                this.modeData.modeTitle = '巩固练习'
                this.isPracticeMode = true
                return
            }
            if (childItem.mode == 1) {
                this.$router.push({path:'/questionPaper1',query: { payload: encodeURIComponent(JSON.stringify(this.payload)) }})
            } else {
                this.$router.push({path:'/questionPaper2',query:  {payload: encodeURIComponent(JSON.stringify(this.payload)) }})
            }
        },
        async getHomeWorkDetailList(){
            const data = {
                page: this.page,
                page_nums: 20,
                course_id: this.courseId,
                class_id: this.classId
            }
            if(this.keyword) {
                data.keyword = this.keyword
            }
            if (this.active == 1) {
                data.read_class = this.read_class
            }
            if(this.active == 2) {
                data.flag = 0
            }else if (this.active == 3) {
                data.flag = 1
            }
            const api = this.active == 1 ? '/user/index/homeworkListByChapter' : '/user/index/chapterTaskAlready'
            const res = await this.$api.post(api,data)
            if(res.data.code == 200) {
                this.chapterList = [...this.chapterList, ...res.data.data.list]
                res.data.data.list.forEach(() => {
                    this.activeNames.push([0])
                })
                this.total = res.data.data.count
                this.pageSize = (this.total > 20 ? Math.ceil(this.total/20) : 1)
            }
        },
        handleScroll(){
            let dom = window.document.documentElement || window.document.body
            //文档内容实际高度（包括超出视窗的溢出部分）
            let scrollHeight = Math.max(dom.scrollHeight, dom.scrollHeight);
            //滚动条滚动距离
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            //窗口可视范围高度
            let clientHeight = dom.innerHeight || Math.min(dom.clientHeight,dom.clientHeight);
            if(clientHeight + scrollTop+10 >= scrollHeight){
                if(this.page >= this.pageSize ) return
                this.page++
                this.getHomeWorkDetailList()
            }
        },
        tabChange(){
            this.page = 1
            this.chapterList = []
            this.keyword = ''
            this.activeNames = []
            this.read_class = 0
            this.getHomeWorkDetailList()
            sessionStorage.setItem('cacheHomework',JSON.stringify({active:this.active}))
        },
        handleBack(){
            this.$router.go(-1)
        },
        handleSearchHomework(){
            console.log('search', this.keyword)
            this.chapterList = []
            this.page = 1
            this.getHomeWorkDetailList()
        },
        onRefresh() {
            this.handleSearchHomework()
            setTimeout(() => {
                this.isLoading = false;
            }, 1000);
        },
        practiceClick() {
            console.log('点击了练习次数', this.payload)
            this.$router.push({path:'/practiceHistory',query: { payload: encodeURIComponent(JSON.stringify(this.payload)), exerciseData:encodeURIComponent(JSON.stringify(this.exerciseData)) }})
        },
        selectMode(type) {
            /* 1：考试模式 2：逐题模式 */
            console.log('选择了哪个模块', type)
            this.payload = { ...this.payload, modeType: type }
            console.log(this.payload)
            if (this.workType == 'doPractice') {
                this.payload.isConsolidation = true
            }
            if (type == 1) {
                this.$router.push({path:'/questionPaper1',query: { payload: encodeURIComponent(JSON.stringify(this.payload)) }})
            } else {
                this.$router.push({path:'/questionPaper2',query:  {payload: encodeURIComponent(JSON.stringify(this.payload)) }})
            }
        },
        modeClose() {
            this.isPracticeMode = false
        }
    }
}
</script>

<style lang="scss" scoped>
.wrap{
  width: 100%;
  height: 100%;
  background: #F0F4F5;
}
.header{
    box-sizing: border-box;
    padding: 0 10px 0 20px;
    background: #ffffff;
    ::v-deep .van-tab--active{
        font-weight: 600;
    }
    ::v-deep .van-tab{
        color: #7E8180;
        font-weight: 600;
        font-size: 15px;
    }
}
.line{
    width: 100%;
    height: 1px;
    background: #E3E8E9;
}

.main {
    box-sizing: border-box;
    padding: 0 10px 10px;
    background: #F0F4F5;
    min-height: calc(100vh - 50px - 50px - 50px);
    .collapseList {
        margin-bottom: 8px;
        &:last-child {
            margin-bottom: 0;
        }
        ::v-deep .van-cell {
            font-size: 16px;
            padding: 12px 12px 10px 12px;
        }
        .hint {
            // min-width: 140px;
            margin-left: 12px;
            span {
                display: inline-block;
                min-width: 16px;
                text-align: center;
            }
        }
    }
    .list {
        width: 100%;
        color: #202020;
        font-size: 14px;
        .list-item {
            padding: 12px 0 0;
            box-sizing: border-box;
            border-top: 1px solid #F0F4F5;
            margin-top: 12px;
            &:first-child {
                margin-top: 0;
            }
            &.done {
                border: 1px solid #e3e8e9;
                border-radius: 8px;
                padding: 12px;
            }
            .chapter-title {
                display: flex;
                .wordage {
                    font-size: 16px;
                    flex: 1;
                }
            }

            .chapter-des {
                margin-top: 8px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .topicNum-time {
                    display: flex;
                    color: #848586;
                    font-size: 12px;
                    .time {
                        margin-left: 8px;
                    }
                }
            }
            .scoreStatus {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 8px;
                .score {
                    background-color: #EAF1FF;
                    padding: 4px 8px;
                    box-sizing: border-box;
                    border-radius: 4px;
                    display: flex;
                    font-size: 12px;
                    color: #286BFF;
                    &.running {
                        background-color: #E8F8F3;
                        color: #10B881;
                    }
                    img {
                        width: 16px;
                        height: 17px;
                    }
                    .scoreNum {
                        margin-left: 4px;
                        .whipptree {
                            color: #C9CDD4;
                            margin: 0 4px;
                        }
                    }
                }
                .status {
                    display: flex;
                    align-items: center;
                    .tag {
                        padding: 2px 4px;
                        border-radius: 4px;
                        margin-left: 2px;
                        font-size: 10px;
                        &.late {
                            background-color: #FFE8E5;
                            color: #F53F3F;
                        }
                        &.noReviewed {
                            background-color: #EBEEF4;
                            color: #202020;
                        }
                        &.reviewed {
                            background-color: #E2F6FF;
                            color: #2497CB;
                        }
                    }
                }
            }
            .btnBox {
                font-size: 12px;
                display: flex;
                .btn {
                    padding: 4px 12px;
                    box-sizing: border-box;
                    color: #ffffff;
                    background-color: #286BFF;
                    border-radius: 100px;
                    &.btnFlexDisabled {
                        background-color: #ccc;
                    }
                }
                &.btnFlexDone {
                    margin-top: 8px;
                    justify-content: flex-end;
                    .btnFlex {
                        width: calc(50% - 4px);
                        text-align: center;
                        &.practice {
                            background-color: #EBEEF4;
                            color: #202020;
                        }
                        &:last-child {
                            margin-left: 8px;
                        }
                    }
                    .zhuti {
                        background-color: #EBEEF4;
                        color: #9A9C9F;
                    }
                }
            }
        }
    }
    ::v-deep .van-cell__value {
        flex: initial;
        font-size: 14px;
        color: #848586;
    }
}

.search-box{
    padding: 8px 10px 8px;
    box-sizing: border-box;
    background-color: #F0F4F5;
    ::v-deep .van-search{
      padding: 0;
      box-sizing: border-box;
      border-radius: 18px;
    }
    ::v-deep .van-search__content{
      background-color: #ffffff;
    }
    ::v-deep .van-icon-search{
      font-weight: 700;
    }
    
    ::v-deep input[type=search]::placeholder {
            color: #7E8180;
    }
}

.flex-algin-center {
    display: flex;
    align-items: center;
}

.done1 {
    color: #FF7D00;
}
.done2 {
    color: #10B881;
}
.done3 {
    color: #286BFF !important;
}
.done4 {
    color: #10B881 !important;
}


.borderRadius8 {
    border-radius: 8px;
}

.clamp2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
}
::v-deep .van-collapse-item__title {
    border-radius: 8px;
}
::v-deep .van-collapse-item__content {
    border-radius: 0 0 8px 8px;
    padding-top: 0;
    padding-left: 12px;
    padding-right: 12px;
}
::v-deep .van-collapse-item__title--expanded {
    border-radius: 8px 8px 0 0;
}
::v-deep .van-pull-refresh {
    min-height: calc(100vh - 50px - 34px - 8px - 20px - 50px);
}
::v-ddep .van-cell__title {
    text-align: justify;
}
</style>